var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.proptyp == "proptyptext"
        ? [
            _vm._l(_vm.returnProp, function(prop) {
              return [
                _c(
                  "label",
                  {
                    staticClass: "d-flex customer-prop align-items-center",
                    class: { active: prop.value == 1 },
                    attrs: { for: prop.PropertyId }
                  },
                  [
                    _c("div", [
                      _c("img", {
                        attrs: { src: _vm.img, alt: "propertyImage" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check flex-fill mb-0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: prop.value,
                            expression: "prop.value"
                          }
                        ],
                        staticClass: "form-check-input d-none",
                        attrs: {
                          type: "checkbox",
                          value: "",
                          id: prop.PropertyId
                        },
                        domProps: {
                          checked: Array.isArray(prop.value)
                            ? _vm._i(prop.value, "") > -1
                            : prop.value
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = prop.value,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(prop, "value", $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      prop,
                                      "value",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(prop, "value", $$c)
                              }
                            },
                            function($event) {
                              return _vm.customerPropCheck(prop)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "customerPropText",
                        domProps: { innerHTML: _vm._s(_vm.desc) }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "check",
                        class: { active: prop.value == 1 }
                      },
                      [_c("i", { staticClass: "fa fa-check" })]
                    )
                  ]
                )
              ]
            })
          ]
        : _vm.proptyp == "myAccount"
        ? [
            _vm._l(_vm.returnProp, function(prop, index) {
              return [
                _c("div", { staticClass: "input-unit" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: prop.value,
                        expression: "prop.value"
                      }
                    ],
                    staticClass: "prop",
                    attrs: { type: "text", maxlength: "100" },
                    domProps: { value: prop.value },
                    on: {
                      blur: function($event) {
                        return _vm.customerPropBlur(prop)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(prop, "value", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "prop" } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(prop.Name) +
                        "\n                "
                    )
                  ])
                ])
              ]
            })
          ]
        : _vm.proptyp == "checkout"
        ? [
            _vm._l(_vm.returnProp, function(prop) {
              return prop.defaultValue != 1
                ? [
                    _c(
                      "label",
                      {
                        staticClass: "d-flex customer-prop align-items-center",
                        class: { active: prop.value == 1 },
                        attrs: { for: prop.PropertyId }
                      },
                      [
                        _c("div", [
                          _c("img", {
                            attrs: { src: _vm.img, alt: "propertyImage" }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-check flex-fill mb-0" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: prop.value,
                                  expression: "prop.value"
                                }
                              ],
                              staticClass: "form-check-input d-none",
                              attrs: {
                                type: "checkbox",
                                value: "",
                                id: prop.PropertyId
                              },
                              domProps: {
                                checked: Array.isArray(prop.value)
                                  ? _vm._i(prop.value, "") > -1
                                  : prop.value
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = prop.value,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = "",
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            prop,
                                            "value",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            prop,
                                            "value",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(prop, "value", $$c)
                                    }
                                  },
                                  function($event) {
                                    return _vm.customerPropCheck(prop)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "customerPropText",
                              domProps: { innerHTML: _vm._s(_vm.desc) }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "check",
                            class: { active: prop.value == 1 }
                          },
                          [_c("i", { staticClass: "fa fa-check" })]
                        )
                      ]
                    )
                  ]
                : _vm._e()
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }